import * as AdaptiveCards from 'adaptivecards';
import AdaptivePersona from '../components/AdaptivePersona';

export const registerCustomAdaptiveCardElements = () => {
    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
        'ActivityPersona',
        () => new AdaptivePersona()
    );
};
